/**
 * Native `<input type="range">` обёртка для радиуса круга-пикера на PhotoPicker
 * (Экран 2.2.3). См. ADR-0008 §4: диапазон 5-45% от minSide изображения, шаг 1.
 *
 * Чисто презентационный — не знает image-pixel space, оперирует процентом
 * minSide. Container переводит percent → image-px при отправке в `extractLab`.
 *
 * Native `<input type="range">` выбран намеренно (не custom slider): на 5"
 * экране у мебельщика палец «толстый» — браузерный native имеет proven touch
 * area + accessibility + keyboard. См. ADR-0008 §4 «Почему слайдер, а не
 * pinch-resize».
 */
export interface RadiusSliderProps {
  /** Текущий радиус в percent от minSide (5..45). */
  radiusPercent: number;
  onRadiusChange: (next: number) => void;
}

export const RADIUS_MIN_PERCENT = 5;
export const RADIUS_MAX_PERCENT = 45;

export function RadiusSlider({ radiusPercent, onRadiusChange }: RadiusSliderProps) {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor="radius-slider" className="font-body text-base text-ink m-0">
        Размер круга: {radiusPercent}%
      </label>
      <input
        id="radius-slider"
        type="range"
        min={RADIUS_MIN_PERCENT}
        max={RADIUS_MAX_PERCENT}
        step={1}
        value={radiusPercent}
        aria-label="Размер круга"
        onChange={(e) => onRadiusChange(Number(e.target.value))}
        className="w-full min-h-tap focus-visible:ring-2 focus-visible:ring-cta"
      />
    </div>
  );
}
